import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import ExposedVisitListEnhanced from "../ExposedVisitList/ExposedVisitListEnhanced"
import { entitiesPropTypes } from "../../utils/propTypes"
import "./ExposedVisitListModal.scss"

const ExposedVisitListModal = (props) => {
  const [modal, setModal] = useState(false)
  useEffect(() => {
    props.userId && props.startAt && props.endAt && setModal(true)
  }, [props])

  const closeButton = (
    <button
      className="close-button fa fa-times"
      type="button"
      title="button"
      onClick={() => setModal(!modal)}
    />
  )

  return (
    <Modal
      isOpen={modal}
      size={"lg"}
      centered={true}
      className={"exposed-employee-visits"}
    >
      <ModalHeader close={closeButton}>
        <div className="hidden">Employee</div>
      </ModalHeader>
      <ModalBody>
        {props.userId && props.startAt && props.endAt && (
          <ExposedVisitListEnhanced {...props} />
        )}
      </ModalBody>
    </Modal>
  )
}

ExposedVisitListModal.propTypes = {
  name: PropTypes.string,
  employeeId: PropTypes.string,
  role: PropTypes.string,
  department: PropTypes.string,
  entities: entitiesPropTypes,
  userId: PropTypes.string,
  startAt: PropTypes.string,
  endAt: PropTypes.string,
}

export default ExposedVisitListModal
